module.exports = "/_next/static/images/6e2effe1f33add7890ba1defe7c9ce68-slide4desktop.jpg.webp";